import './styles.css';

import BadgeMaster from './images/badge-master.png';
import BadgeWarrior from './images/badge-warrior.png';
import BadgeNewbie from './images/badge-newbie.png';
import BadgeNoob from './images/badge-noob.png';
import ArrowTopGreen from './images/icon-arrow-top-green.svg';
import ArrowBottomRed from './images/icon-arrow-bottom-red.svg';

export default function BadgePoints({
  rank, 
  points,
  firstAttemptPoints,
  onBadgeInfoButtonClick
}) {
  const badgeImages = {
    Master: BadgeMaster,
    Warrior: BadgeWarrior,
    Newbie: BadgeNewbie,
    Noob: BadgeNoob,
  };

  const arrowImage = firstAttemptPoints > 0
    ? firstAttemptPoints > points
      ? ArrowBottomRed
      : ArrowTopGreen
    : null;

  const handleInfoButtonClick = () => {
    onBadgeInfoButtonClick && onBadgeInfoButtonClick();
  }

  return (
    <div className="badge-points-container">
      <div>
        <p>
          Accounting {rank}
          <button 
            className="question-mart-icon"
            onClick={handleInfoButtonClick}
          ></button>
        </p>
        <p className="points">
          {points.toLocaleString('en-US')} points
          {
            arrowImage && (
              <img src={arrowImage} alt="Progress" className="progress-arrow-icon" />
            )
          }
        </p>
      </div>
      {
        rank &&
          <img className="badge-image" src={badgeImages[rank]} alt={`${rank} Badge`} />
      }
    </div>
  );
}
